export function resolveTotalFare(source, currency) {
    if (!source) return 0;
    if (!currency || !source.Currency || source.Currency === currency) {
        return source.TotalFare;
    }
    if (Array.isArray(source.CurrencyMaps)) {
        const match = source.CurrencyMaps.find(m => m.Currency === currency);
        if (match) return match.TotalFare;
    }
    return source.TotalFare;
}

export function resolveFlightTotalFare(flight, currency) {
    if (flight && flight.SelectableFares && flight.SelectableFares.length > 0) {
        return resolveTotalFare(flight.SelectableFares[0], currency);
    }
    return resolveTotalFare(flight, currency);
}

export function resolvePriceField(source, fieldName, currency) {
    if (!source) return 0;
    if (!fieldName || !source[fieldName]) return 0;
    if (!currency || !source.Currency || source.Currency === currency) {
        return source[fieldName];
    }
    if (Array.isArray(source.CurrencyMaps)) {
        const match = source.CurrencyMaps.find(m => m.Currency === currency);
        if (match && match[fieldName]) return match[fieldName];
    }
    return source[fieldName];
}

export function groupFaresByCode(fares) {
    if (!fares || fares.length === 0) return [];
    const groups = {};
    const order = [];
    fares.forEach(fare => {
        if (!groups[fare.FareCode]) {
            groups[fare.FareCode] = JSON.parse(JSON.stringify(fare));
            order.push(fare.FareCode);
        } else {
            const merged = groups[fare.FareCode];
            merged.TotalFare = (merged.TotalFare || 0) + (fare.TotalFare || 0);
            if (fare.CurrencyMaps && Array.isArray(fare.CurrencyMaps)) {
                if (!merged.CurrencyMaps) merged.CurrencyMaps = [];
                fare.CurrencyMaps.forEach(currencyMap => {
                    const existing = merged.CurrencyMaps.find(m => m.Currency === currencyMap.Currency);
                    if (existing) {
                        existing.TotalFare = (existing.TotalFare || 0) + (currencyMap.TotalFare || 0);
                    } else {
                        merged.CurrencyMaps.push(JSON.parse(JSON.stringify(currencyMap)));
                    }
                });
            }
        }
    });
    return order.map(key => groups[key]);
}
